import React from 'react';
import { Redirect, Route } from 'react-router';

import { LOCALSTORAGE }     from 'utils/constants';

import Account                  from 'containers/Accounts/Edit/index';
import Agency                   from 'containers/Accounts/Profile/Agency';
import AgencySignupPage         from 'containers/Auth/Signup/AgencySignupPage';
import App                      from 'containers/App';
import EditPosting              from 'containers/Opportunities/EditPosting'
import Error404                 from 'containers/Errors/Error404'
import ForgotPasswordPage       from 'containers/Auth/ForgotPasswordPage';
import Freelancer               from 'containers/Accounts/Profile/Freelancer';
import Freelancers              from 'containers/Freelancers/Listing';
import FreelancerSignupPage     from 'containers/Auth/Signup/FreelancerSignupPage';
import ListPostings             from 'containers/Opportunities/ListPostings';
import LoginPage                from 'containers/Auth/LoginPage';
import LogoutPage               from 'containers/Auth/LogoutPage';
import Messaging                from 'containers/Messaging';
import Opportunities            from 'containers/Opportunities/Listing';
import OpportunityDetails       from 'containers/Opportunities/OpportunityDetails';
import PricingPage              from 'containers/Auth/Signup/PricingPage';
import PrivacyPolicy            from 'containers/Legal/PrivacyPolicy';
import RecommendAFreelancer     from 'containers/Freelancers/RecommendAFreelancer';
import RequestInvitationPage    from 'containers/Auth/RequestInvitationPage';
import ResetPasswordPage        from 'containers/Auth/ResetPasswordPage';
import TermsAndConditions       from 'containers/Legal/TermsAndConditions';
import Users                    from 'containers/Users';

const requireAuth = (nextState, replace) => {
    if (localStorage.getItem(LOCALSTORAGE.ID_TOKEN) == null) {
        let redirectString = `${window.location.pathname}||${new Date().getTime()}`;
        localStorage.setItem('login_redirect', redirectString);
        replace({ pathname: '/login' })
    }
};

const Routes = (
    <Route          path="/"                                    component={App}>
        <Redirect   from="account"                              to="account/profile" />
        <Route      path="account/:tab"                         component={Account}                 onEnter={requireAuth} />
        <Route      path="business/new"                         component={Account}                 onEnter={requireAuth} />
        <Route      path="business/:id"                         component={Agency}                  onEnter={requireAuth} />
        <Route      path="create-your-user-account"             component={FreelancerSignupPage} />
        <Route      path="forgot-password"                      component={ForgotPasswordPage} />
        <Route      path="freelancers"                          component={Freelancers} />
        <Route      path="freelancer/:id"                       component={Freelancer}              onEnter={requireAuth} />
        <Route      path="freelancer/preview"                   component={Freelancer}              onEnter={requireAuth} />
        <Route      path="invitation/:token"                    component={ResetPasswordPage} />
        <Route      path="login"                                component={LoginPage} />
        <Route      path="logout"                               component={LogoutPage} />
        <Route      path="messages"                             component={Messaging}               onEnter={requireAuth} />
        {/*<Route      path="opportunities"                        component={Opportunities} />
        <Route      path="opportunity/:id"                      component={OpportunityDetails}      onEnter={requireAuth} />*/}
        <Route      path="privacy-policy"                       component={PrivacyPolicy} />
        {/*<Route      path="posting/new"                          component={EditPosting}             onEnter={requireAuth} />
        <Route      path="posting/:id"                          component={EditPosting}             onEnter={requireAuth} />
        <Redirect   from="postings"                             to="postings/published" />
        <Route      path="postings/:tab"                        component={ListPostings}            onEnter={requireAuth} />*/}
        <Route      path="recommend"                            component={RecommendAFreelancer}    onEnter={requireAuth} />
        <Route      path="request-invitation"                   component={RequestInvitationPage} />
        <Route      path="reset-password/:token"                component={ResetPasswordPage} />
        <Route      path="create-your-business-account" exact   component={PricingPage} />
        <Route      path="signup" exact                         component={PricingPage} />
        <Route      path="create-your-business-account/form"    component={AgencySignupPage} />
        <Route      path="terms"                                component={TermsAndConditions} />
        <Route      path="user/new"                             component={Account}                 onEnter={requireAuth} />
        <Route      path="users"                                component={Users}                   onEnter={requireAuth} />
        <Route      path="*" exact={true}                       component={Error404} />
    </Route>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/Root/Routes.js